"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.descriptionContainer = exports.buttonContainer = void 0;
exports.buttonContainer = {
    paddingTop: 50,
};
exports.descriptionContainer = {
    paddingTop: 20,
};
//# sourceMappingURL=ActionWithDescription.styles.js.map